import { useState, useEffect } from "react";

/*
 * useStaleness
 * When midnight passes, Formik date submissions may be blocked.
 * Hint the user when this occurs so they can choose to reload the page (or not)
 *
 */

const useStaleness = () => {
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    const now = new Date();
    const midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      0,
      0,
      0,
    );
    const msUntilMidnight = midnight.getTime() - now.getTime();
    const timeoutId = setTimeout(() => {
      setIsStale(true);
    }, msUntilMidnight);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return isStale;
};

export default useStaleness;
